/**
 * Created by Ning Jiang on 10/31/2017.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {NudgeStackedSymbolWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/nudge/NudgeStackedSymbolWPController";
import {Elastic, TimelineLite} from "gsap";
import {MultiplierIndicator} from "../../multiplier/MultiplierIndicator";
import {WildNudgeNudgeReelController} from "../../reel/nudgereel/WildNudgeNudgeReelController";
import {BurningReelSymbol} from "../../reelsymbol/BurningReelSymbol";
import {SymbolBurstAnimator} from "../../reelsymbol/SymbolBurstAnimator";
import {WildNudgeParsedGameData} from "../../server/data/WildNudgeParsedGameData";
import {WildNudgeSoundConfig} from "../../WildNudgeSoundConfig";
import {WildNudgeNudgeStackedSymbolWPView} from "./WildNudgeNudgeStackedSymbolWPView";

export class WildNudgeNudgeStackedSymbolWPController extends NudgeStackedSymbolWPController {

    private _nudgeSymbol:string[];
    private _isNudging:boolean = false;
    private _currentMultiplier:number;
    private _stackedSpinTriggered:boolean;
    private _activeStackedSymbol:string;
    private _lastNudgeReelId:number;

    private _view:WildNudgeNudgeStackedSymbolWPView;
    private _endingTimeline:TimelineLite | null;

    constructor(indexes:[number, number]) {
        super(indexes, {nudgeStepSpeed : 0.6, stackedSymbolKeyword : "W"});

        this._view = new WildNudgeNudgeStackedSymbolWPView();
    }

    protected parseFeatureGameData(data:WildNudgeParsedGameData) {
        super.parseFeatureGameData(data);
        this._stackedSpinTriggered = data.stackedSpinTriggered;
        this._activeStackedSymbol = data.activeStackedSymbol;
    }

    protected startWinPresentation():void {
        if(this._noWinNudge) {
            EventHandler.dispatchEvent(new GameEvent(MultiplierIndicator.UPDATE_MULTIPLIER, this._gameData!.currentMultiplier));
            this.finish();
            return;
        }

        this._isNudging = true;
        let delay:number = 0;
        this._nudgeData!.doReelNudge.forEach((doNudge:boolean, reelId:number) => {
            if(doNudge) {
                this.nudgeReel(reelId, delay);
                delay += this.getNextReelNudgeDelayDelta(reelId);
            }
        });
    }

    private nudgeReel(reelId:number, delay:number):void {
        this._nudgeState[reelId] = true;
        const symbols:string[] = this._gameData!.reels[reelId];

        if(this.tryNudge("W", 0, reelId, symbols, delay) || this.tryNudge("W", 3, reelId, symbols, delay)
            || (this._stackedSpinTriggered && (this.tryNudge(this._activeStackedSymbol, 0, reelId, symbols, delay) || this.tryNudge(this._activeStackedSymbol, 3, reelId, symbols, delay)))) {
            return;
        }

        debugger;
        throw new Error(`NudgeWildWPController.doReelNudge():There is no W or X->${this._activeStackedSymbol} in a nudging reel. reelId = ${reelId}, symbols = ${symbols.toString()}`);
    }

    private tryNudge(symbol:string, stackIndex:number, reelId:number, reelSymbols:string[], delay:number):boolean {
        let index:number = reelSymbols.indexOf(`${symbol}*${stackIndex.toString()}`);
        if(MathHelper.isInRange(index, 1, 4)) {
            // if(symbol === "W") {
            //     if(this._nudgeData!.overlayWilds == null || this._nudgeData!.overlayWilds![reelId].indexOf(false) > -1) {
            //         debugger;
            //         Logger.logDev(`NudgeWildWPController.tryNudge, reelId = ${reelId}, server data overlayWilds has false!`);
            //     }
            //
            // } else if(this._nudgeData!.stackOverlay == null || this._nudgeData!.stackOverlay[reelId].indexOf(false) > -1) {
            //     // debugger;
            //     Logger.logDev(`NudgeWildWPController.tryNudge, reelId = ${reelId}, server data stackOverlay has false!`);
            // }

            this._steps[reelId] = stackIndex + 1 - index;
            (<WildNudgeNudgeReelController>Reels.getReel(reelId)).nudge(this._steps[reelId], this._nudgeConfig.nudgeStepSpeed, Elastic.easeIn.config(1, 1), delay);
            this._nudgeSymbol[reelId] = symbol;
            return true;
        }

        return false;
    }

    protected playOnNudgeStepComplete(reelId:number, stepsLeft:number):void {
        EventHandler.dispatchEvent(new GameEvent(SymbolBurstAnimator.PLAY_STACKED_SMOKE, reelId, 3));

        if(!this._nudgeAborted) {
            if(this._nudgeSymbol[reelId] === "W") {
                SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.WILD_NUDGE);
            } else {
                SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.RANDOM_FEATURE_NUDGE);
            }
        }

        if(this._nudgeSymbol[reelId] === "W") {
            this._currentMultiplier++;
            this._view.showMultiplier(`X${this._currentMultiplier.toString()}`, this._currentMultiplier === this._gameData!.currentMultiplier);
            EventHandler.dispatchEvent(new GameEvent(MultiplierIndicator.UPDATE_MULTIPLIER));
        }
    }

    protected onNudgeCompleted(reelId:number, aborted:boolean):void {
        if(!this._isNudging) {
            return;
        }

        super.onNudgeCompleted(reelId, aborted);
    }

    protected playOnReelNudgeComplete(reelId:number, aborted:boolean) {
        this._lastNudgeReelId = reelId;
    }

    protected playOnAllNudgeComplete(aborted:boolean):void {
        // Stop fire on all nudged stacked symbols when all nudge is completed.
        this._nudgeSymbol.forEach((symbol:string, reelId:number) => {
            if(symbol.length > 0) {
                const symbol:BurningReelSymbol = <BurningReelSymbol>Reels.getSymbol(reelId, 3);
                if(symbol) {
                    symbol.stopFireOverlay(0.5, true, true);
                }
            }
        });

        this._endingTimeline = new TimelineLite();
        this._endingTimeline.add(() => this.finish(), this._nudgeSymbol[this._lastNudgeReelId] === "W" ? 0.5 : 0); // don't add delay when nudging med symbols.
        this._endingTimeline.play();
    }

    public abort():void {
        super.abort();
        if(this._isPlaying && this._skippable) {
            if(this._nudgeAborted) {
                if(this._nudgeSymbol.some((symName:string) => symName === "W")) {
                    this._view.showMultiplier(`X${this._gameData!.currentMultiplier}`, false);
                }
                SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.SCATTER_LANDING_2);
            }
        }
    }

    protected stopWinPresentation():void {
        if(this._endingTimeline && this._endingTimeline.isActive()) {
            this._endingTimeline.paused();
            this._endingTimeline.kill();
        }
        this._isNudging = false;
    }

    protected resetFeature():void {
        super.resetFeature();
        this._currentMultiplier = 1;
        this._lastNudgeReelId = -1;
        this._nudgeSymbol = ArrayHelper.initArrayWithValues<string>(5, () => "");
    }
}